import React, { useState, useEffect } from 'react';
import { Typography, Space, Button, Table, Input, Image, Tag, Popconfirm } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import WorkflowAccOpeningService from '../../services/WorkflowAccOpeningService';
import ModalForm from '../../components/ModalForm/ModalForm';
import SecurityCompanyService from '../../services/SecurityCompanyService';

const { Title } = Typography;

export default function SecurityCompany() {
  const location = useLocation();
  const [applicationList, setApplicationList] = useState([]);
  const navigate = useNavigate();
  const { user, showNotification } = useAuth();
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false)
  // Read application list
  const loadData = async () => {
    // const searchParams = new URLSearchParams(location.search);
    // const pageParam = searchParams.get('page') || 1;
    // const sizeParam = searchParams.get('size') || 10;
    // setPage(Number(pageParam) || 1);
    // setSize(Number(sizeParam) || 10);
    setLoading(true);
    const response = await SecurityCompanyService.getSecurityCompanyList({
      // page: pageParam,
      // size: sizeParam,
    });

    if (response.success === true) {
      setApplicationList(
        response.securityCompanyList.map(data => ({
          ...data,
          key: data.securityCompanyId,
        })),
      );
      setTotalCount(response.securityCompanyList.length);
    } else {
      showNotification('error', response.message);
    }
    setLoading(false);
  };


  useEffect(() => {
    loadData();
  }, [location.search]);


  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current)
    setSize(pagination.pageSize)
    // navigate(`/?page=${pagination.current}&size=${pagination.pageSize}`);
  };

  // Table columns
  const tableColumns = [
    {
      title: 'Security Company Id',
      dataIndex: 'securityCompanyId',
      key: 'securityCompanyId',
    },
    {
      title: 'Security Company Name',
      dataIndex: 'securityCompanyName',
      key: 'securityCompanyName',
    },
    {
      title: 'AMI Code',
      dataIndex: 'amiCode',
      key: 'amiCode',
    },
    {
      title: 'Share Settlement Account No',
      dataIndex: 'shareSettlementAccNo',
      key: 'shareSettlementAccNo',
    },
    
  ];

  const formItems = [
    { 
        label : "Security Company Name", 
        name : "securityCompanyName", 
        type : "input"
    },
    { 
        label : "AMI Code", 
        name : "AMICode", 
        type : "input"
    },
    { 
        label : "Share Settlement Acc No", 
        name : "shareSettlementAccNo", 
        type : "input"
    },
]

    const handleSubmit = async(formValues) => {
        console.log(formValues)
        const res = await SecurityCompanyService.createSecurityCompany(formValues);
        if(res.success){
            showNotification("success", "Created!")
            setShowModal(false)
            loadData()
        }else{
            showNotification("error", res.message)
        }
    }
  return (
    <>
      <Space
        direction="horizontal"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <Title level={4} style={{ margin: 0 }}>
          Security Company
        </Title>
        {user.role == 'ADMIN' || user.role == 'MAKER' ? (
          <Button
            type="primary"
            size={'middle'}
            // icon={<PlusCircleOutlined />}
            onClick={() => setShowModal(true)}
          >
            Create
          </Button>
        ) : null}
      </Space>
        {
            showModal && (
                <ModalForm title="Security Company" formItems={formItems} open={showModal} toggleModal={() => setShowModal(false)} apiCall={handleSubmit}/>
            )
        }
        
      <Table
        columns={tableColumns}
        dataSource={applicationList}
        size={'large'}
        scroll={{
          x: 'max-content',
        }}
        bordered
        pagination={{
          current: page,
          pageSize: size,
          total: totalCount,
        }}
        onChange={handleTableChange}
        loading={loading}
      />
    </>
  );
}
